import { Link } from 'react-router-dom';
import { Camera, Search, Droplets, CreditCard } from 'lucide-react';

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center space-y-16 py-12">
      <div className="text-center max-w-3xl">
        <h1 className="text-5xl font-extrabold tracking-tight text-slate-900 mb-6">
          The Marketplace for <span className="text-blue-600">Surf Photography</span>
        </h1>
        <p className="text-xl text-slate-600 mb-10">
          Find your best waves captured by local photographers, or turn your surf shots into cash.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/surfer" className="px-8 py-4 bg-slate-900 text-white font-semibold rounded-lg hover:bg-slate-800 transition-colors flex items-center justify-center gap-2 text-lg">
            <Search className="h-5 w-5" />
            Find My Photos
          </Link>
          <Link to="/photographer" className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 text-lg">
            <Camera className="h-5 w-5" />
            I'm a Photographer
          </Link>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 w-full mt-12">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center">
          <div className="h-12 w-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
            <Droplets className="h-6 w-6" />
          </div>
          <h3 className="text-lg font-bold mb-2">Search by Details</h3>
          <p className="text-slate-600">Find photos by beach, date, wetsuit color, or surfboard type. Never miss a shot.</p>
        </div>
        
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center">
          <div className="h-12 w-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
            <Camera className="h-6 w-6" />
          </div>
          <h3 className="text-lg font-bold mb-2">Auto-Watermarks</h3>
          <p className="text-slate-600">Photographers upload high-res files; we handle the watermarked previews automatically.</p>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center">
          <div className="h-12 w-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
            <CreditCard className="h-6 w-6" />
          </div>
          <h3 className="text-lg font-bold mb-2">Easy Payouts & Buying</h3>
          <p className="text-slate-600">1-click buy for surfers. Direct bank payouts for photographers. Simple.</p>
        </div>
      </div>
    </div>
  );
}
